import React, { useContext, useEffect, useState } from 'react';
import requestCheck from 'assets/images/Dashboard/chevron-right-request.svg';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import ArrowDetail from 'assets/images/Dashboard/arrow-left-request-detail.svg';
import ReusableButton from 'components/commom/Button';
import { FormattedMessage } from 'react-intl';
import MobileIcon from 'assets/images/Dashboard/call-request-detail.svg';
import MailIcon from 'assets/images/Dashboard/mail-request-detail.svg';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getRequestDetailData } from 'store/requestDetail/requestDetailAction';
import moment from 'moment';
import { postAdminRequest } from 'store/requestPost/requestPostAction';
import { request } from 'routes/AppUrls';
import { ClearTokenRedirectLogin } from 'utils/general';
import Shimmer from 'components/commom/Shimmer';
import RequestDetailFooter from './RequestDetailFooter';
import Download from 'assets/images/Dashboard/dowload.svg';
import CommonToast from 'components/commom/CommonToast';
import CommonModal from 'components/commom/Modal';
import CommonRadioGroup from 'components/commom/RadioButtonGroup';
import LabelWithTextArea from 'components/commom/LabelWithTextArea';
import CheckValidation from 'utils/validate';

const RequestDetail = () => {
  const { locale } = useContext(LocaleContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const [requestDetail, seRequestDetail] = useState();
  const [isModalActive, setIsModalActive] = useState(false);
  const [typeDoctor, setTypeDoctor] = useState('Internal');
  const [buttonType, setButtonType] = useState('');
  const [rejectModal, setRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [isError, setIsError] = useState(false);

  const requestDetailId = useSelector(
    (state) => state?.basicDetailsValueReducer?.requestDetailId
  );

  const requestDetailValue = useSelector(
    (state) => state?.basicDetailsValueReducer?.requestDetailValue
  );

  const requestReducer = useSelector(
    (state) => state?.requestPostReducer?.loading
  );

  const requestDetailReducer = useSelector(
    (state) => state?.requestDetailReducer?.loading
  );

  useEffect(() => {
    requestValue();
  }, []);

  const requestValue = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        seRequestDetail(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getRequestDetailData(external, requestDetailId));
  };

  const handlePromoteRequest = () => {
    setButtonType('promote');
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        navigate(request(locale));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {
      request_id: requestDetail?.request_info?.id,
    };
    if (requestDetailValue === 'request') {
      body.is_promoted = true;
      dispatch(postAdminRequest(body, external));
    }
    if (requestDetailValue === 'in-review') {
      setIsModalActive(true);
      // body.is_approved = true;
      // dispatch(postAdminRequest(body, external));
    }
    if (requestDetailValue === 'approved') {
      body.on_hold = true;
      dispatch(postAdminRequest(body, external));
    }
    if (requestDetailValue === 'on-hold') {
      body.is_approved = true;
      dispatch(postAdminRequest(body, external));
    }

    // dispatch(postAdminRequest(body, external));
  };
  const handleRemoveRequest = () => {
    setButtonType('reject');
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        setRejectModal(false);
        navigate(request(locale));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    const error = CheckValidation({ rejectReason });
    setIsError(error);
    if (error.submit) {
      let body = {
        request_id: requestDetail?.request_info?.id,
        is_rejected: true,
        reason: rejectReason,
      };
      dispatch(postAdminRequest(body, external));
    }
  };

  const handleCloseModal = () => {
    setIsModalActive(false);
  };

  const handleTypeDoctor = (e) => {
    setTypeDoctor(e.target.value);
  };

  const handleTypeDoctorApprove = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        handleCloseModal();
        navigate(request(locale));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {
      request_id: requestDetail?.request_info?.id,
      is_approved: true,
      ...(typeDoctor === 'Internal' && { is_internal: true }),
    };

    dispatch(postAdminRequest(body, external));
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainerrequest lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainerrequest lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="flex pb-16">
            <div className="fs-12 lh-24 family_outfit_regular_400">
              Requests
            </div>
            <div className="pl-04 flex items-center">
              <Image src={requestCheck} alt="icon" />
            </div>
            <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
              View Details
            </div>
          </div>
          <Row className="bg-light-100 m-0 p-24">
            <Col sm={12} className="p-0">
              <div className="flex justify-between">
                <div className="flex items-center">
                  <div>
                    <Image
                      src={ArrowDetail}
                      alt="icon"
                      onClick={() => navigate(-1)}
                      className="cursor-pointer"
                    />
                  </div>
                  <div className="fs-20 lh-252 family_outfit_semiBold_600 fc-292D32 pl-12">
                    {requestDetailValue === 'request'
                      ? 'Request Details'
                      : 'Provider Details'}
                  </div>
                </div>

                <div>
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="items-center justify-end p-0"
                  >
                    {requestDetailValue !== 'approved' && (
                      <ReusableButton
                        fullWidth={false}
                        variant="outlined"
                        color="#864629"
                        fontSize="16px"
                        fontWeight="400"
                        padding="14px 26.5px"
                        height="44px"
                        bgColor="transparent"
                        brColor="#EFE3D7"
                        fontFamily="outfit_regular"
                        onClick={() => {
                          // !requestReducer && handleRemoveRequest();
                          setRejectModal(true);
                          setRejectReason('');
                        }}
                        // loading={requestReducer && buttonType === 'reject'}
                      >
                        <FormattedMessage id="Delete" />
                      </ReusableButton>
                    )}

                    <div>
                      {requestDetailValue === 'request' ? (
                        <ReusableButton
                          fullWidth={false}
                          variant="contained"
                          color="#F5F5F5"
                          fontSize="16px"
                          fontWeight="500"
                          padding="14px 49px"
                          height="44px"
                          bgColor="#864629"
                          brColor="#864629"
                          fontFamily="outfit_medium"
                          onClick={() => {
                            !requestReducer && handlePromoteRequest();
                          }}
                          loading={requestReducer && buttonType === 'promote'}
                        >
                          <FormattedMessage id="Promote" />
                        </ReusableButton>
                      ) : requestDetailValue === 'in-review' ? (
                        <ReusableButton
                          fullWidth={false}
                          variant="contained"
                          color="#F5F5F5"
                          fontSize="16px"
                          fontWeight="500"
                          padding="14px 49px"
                          height="44px"
                          bgColor="#864629"
                          brColor="#864629"
                          fontFamily="outfit_medium"
                          onClick={() => {
                            !requestReducer && handlePromoteRequest();
                          }}
                          loading={requestReducer}
                        >
                          <FormattedMessage id="Approve" />
                        </ReusableButton>
                      ) : requestDetailValue === 'approved' ? (
                        <ReusableButton
                          fullWidth={false}
                          variant="contained"
                          color="#F5F5F5"
                          fontSize="16px"
                          fontWeight="500"
                          padding="14px 49px"
                          height="44px"
                          bgColor="#864629"
                          brColor="#864629"
                          fontFamily="outfit_medium"
                          onClick={() => {
                            !requestReducer && handlePromoteRequest();
                          }}
                          loading={requestReducer}
                        >
                          <FormattedMessage id="On Hold" />
                        </ReusableButton>
                      ) : (
                        <ReusableButton
                          fullWidth={false}
                          variant="contained"
                          color="#F5F5F5"
                          fontSize="16px"
                          fontWeight="500"
                          padding="14px 49px"
                          height="44px"
                          bgColor="#864629"
                          brColor="#864629"
                          fontFamily="outfit_medium"
                          onClick={() => {
                            !requestReducer && handlePromoteRequest();
                          }}
                          loading={requestReducer}
                        >
                          <FormattedMessage id="Approve" />
                        </ReusableButton>
                      )}
                    </div>
                  </Stack>
                </div>
              </div>
              <div className="fs-18 family_outfit_semiBold_600 lh-2268 fc-292D32 pt-24">
                Personal Details
              </div>
              <Row className="pt-24 m-0">
                <Col sm={6} lg={3} className="p-0 m-0">
                  <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                    Provider
                  </div>
                  <div className="fs-18 lh-2268 fc-202224 family_outfit_medium_500 pt-8">
                    {requestDetailReducer ? (
                      <Shimmer width="250px" height="20px" />
                    ) : (
                      requestDetail?.full_name
                    )}
                  </div>
                  {requestDetailReducer ? (
                    <Shimmer width="250px" height="20px" marginTop={'8px'} />
                  ) : (
                    <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-8">
                      ID:
                      <span className="fs-14 lh-2268 fc-202224 family_outfit_medium_500 pl-8">
                        {requestDetail?.provider_id}
                      </span>
                    </div>
                  )}
                </Col>
                {requestDetailValue !== 'request' && (
                  <Col sm={6} lg={3} className="p-0 m-0">
                    <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                      Degree/Education
                    </div>
                    <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                      {requestDetailReducer ? (
                        <Shimmer width="250px" height="20px" />
                      ) : (
                        requestDetail?.highest_qualification?.qualification
                      )}
                    </div>
                  </Col>
                )}
                {requestDetailValue !== 'request' && (
                  <Col sm={6} lg={3} className="p-0 m-0">
                    <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                      Provider type
                    </div>
                    <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                      {requestDetailReducer ? (
                        <Shimmer width="250px" height="20px" />
                      ) : (
                        requestDetail?.provider_type?.name
                      )}
                    </div>
                  </Col>
                )}
                {requestDetailValue !== 'request' && (
                  <Col sm={6} lg={3} className="p-0 m-0">
                    <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                      Title
                    </div>
                    <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                      {requestDetailReducer ? (
                        <Shimmer width="250px" height="20px" />
                      ) : (
                        requestDetail?.highest_qualification?.provider_type
                      )}
                    </div>
                  </Col>
                )}
              </Row>
              <Row className="pt-24 m-0">
                <Col sm={6} lg={3} className="p-0 m-0">
                  <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                    Mobile number
                  </div>
                  {requestDetailReducer ? (
                    <Shimmer width="250px" height="20px" marginTop={'8px'} />
                  ) : (
                    <div className="flex pt-8">
                      <div>
                        <Image src={MobileIcon} alt="icon" />
                      </div>
                      <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pl-12">
                        {requestDetail?.country_code}{' '}
                        {requestDetail?.contact_number}
                      </div>
                    </div>
                  )}
                </Col>
                <Col sm={6} lg={3} className="p-0 m-0">
                  <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                    Email
                  </div>
                  {requestDetailReducer ? (
                    <Shimmer width="250px" height="20px" marginTop={'8px'} />
                  ) : (
                    <div className="flex pt-8">
                      <div>
                        <Image src={MailIcon} alt="icon" />
                      </div>
                      <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pl-12 break-all ...">
                        {requestDetail?.email}
                      </div>
                    </div>
                  )}
                </Col>
                {requestDetail?.medical_licence !== null && (
                  <Col sm={6} lg={3} className="p-0 m-0">
                    <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                      {requestDetail?.title?.id === 10 ? 'Spa' : 'Medical'}{' '}
                      License
                    </div>
                    <div className="pt-8 flex break-all">
                      <a
                        href={requestDetail?.medical_licence || '#'}
                        download={requestDetail?.medical_licence}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fs-16 lh-201 fc-5B88E9 family_outfit_regular_400 cursor-pointer underline underline-offset-4 flex items-center max-w-[230px]"
                      >
                        {requestDetailReducer ? (
                          <Shimmer
                            width="300px"
                            height="20px"
                            marginTop={'8px'}
                          />
                        ) : (
                          requestDetail?.medical_licence && (
                            <>
                              {/* {requestDetail?.medical_licence.split('/').pop()} */}
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {requestDetail.medical_licence.split('/').pop()}
                              </span>

                              <Image
                                src={Download}
                                alt="icon"
                                className="pl-2"
                              />
                            </>
                          )
                        )}
                      </a>
                    </div>
                  </Col>
                )}
                {requestDetail?.licence_expiry_date !== null && (
                  <Col sm={6} lg={3} className="p-0 m-0">
                    <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                      Licence Expire Date
                    </div>
                    {requestDetailReducer ? (
                      <Shimmer width="250px" height="20px" marginTop={'8px'} />
                    ) : (
                      <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                        {moment(requestDetail?.licence_expiry_date).format(
                          'DD MMM YYYY'
                        )}
                      </div>
                    )}
                  </Col>
                )}
                <Col sm={6} lg={3} className="p-0 m-0">
                  <div
                    className={`fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 ${requestDetail?.medical_licence !== null && requestDetail?.licence_expiry_date !== null && 'pt-24'}`}
                  >
                    Request Date
                  </div>
                  {requestDetailReducer ? (
                    <Shimmer width="250px" height="20px" marginTop={'8px'} />
                  ) : (
                    <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                      {moment(requestDetail?.request_info?.requested_on).format(
                        'DD MMM YYYY'
                      )}
                    </div>
                  )}
                </Col>
                {(requestDetail?.registration_number ||
                  requestDetail?.licence_number) && (
                  <Col sm={6} lg={3} className="p-0 m-0">
                    <div
                      className={`fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-24`}
                    >
                      Registration Number
                    </div>
                    {requestDetailReducer ? (
                      <Shimmer width="250px" height="20px" marginTop={'8px'} />
                    ) : (
                      <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                        {requestDetail?.registration_number ||
                          requestDetail?.licence_number}
                      </div>
                    )}
                  </Col>
                )}
              </Row>
              <Row className="pt-24 m-0">
                {requestDetailValue !== 'request' && (
                  <Col sm={6} lg={3} className="p-0 m-0">
                    <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                      Address
                    </div>
                    <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                      {requestDetailReducer ? (
                        <Shimmer width="250px" height="20px" />
                      ) : (
                        requestDetail?.address?.address_line1
                      )}
                    </div>
                  </Col>
                )}
                {requestDetailValue !== 'request' && (
                  <Col sm={6} lg={3} className="p-0 m-0">
                    <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                      Street Address
                    </div>
                    <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                      {requestDetailReducer ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'8px'}
                        />
                      ) : (
                        requestDetail?.address?.address_line1
                      )}
                    </div>
                  </Col>
                )}
                <Col sm={6} lg={3} className="p-0 m-0">
                  <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                    Country
                  </div>
                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                    {requestDetailReducer ? (
                      <Shimmer width="250px" height="20px" marginTop={'8px'} />
                    ) : (
                      requestDetail?.address?.country?.name
                    )}
                  </div>
                </Col>
                <Col sm={6} lg={3} className="p-0 m-0">
                  <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400">
                    State
                  </div>
                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                    {requestDetailReducer ? (
                      <Shimmer width="250px" height="20px" marginTop={'8px'} />
                    ) : (
                      requestDetail?.address?.state?.name
                    )}
                  </div>
                </Col>
                <Col sm={6} lg={3} className="p-0 m-0">
                  <div
                    className={`fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 ${requestDetailValue !== 'request' && 'pt-24'}`}
                  >
                    City
                  </div>
                  <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                    {requestDetailReducer ? (
                      <Shimmer width="250px" height="20px" marginTop={'8px'} />
                    ) : (
                      requestDetail?.address?.city?.name
                    )}
                  </div>
                </Col>
                {requestDetailValue !== 'request' && (
                  <Col sm={6} lg={3} className="p-0 m-0">
                    <div className="fs-14 lh-176 fc-A4AAB2 family_outfit_regular_400 pt-24">
                      ZIP Code
                    </div>
                    <div className="fs-16 lh-201 fc-202224 family_outfit_regular_400 pt-8">
                      {requestDetailReducer ? (
                        <Shimmer
                          width="250px"
                          height="20px"
                          marginTop={'8px'}
                        />
                      ) : (
                        requestDetail?.address?.zip_code
                      )}
                    </div>
                  </Col>
                )}
              </Row>
              {requestDetailValue !== 'request' && <RequestDetailFooter />}
            </Col>
          </Row>
        </Col>
      </Row>
      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={isModalActive}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="fs-24 pt-8 sm:pt-24 family_outfit_semiBold_600">
                  Approve Doctor Profile
                </div>
                <div className="mt-16 fs-16 family_outfit_regular_400 lh-208 fc-7B998A pt-12">
                  Do you want to approve this doctor as an internal doctor or
                  external doctor?
                </div>
                <div className="pt-20">
                  <CommonRadioGroup
                    name="typeDoctor"
                    value={typeDoctor}
                    onChange={handleTypeDoctor}
                    options={[
                      {
                        value: 'Internal',
                        label: 'Approve as Internal Doctor',
                      },
                      {
                        value: 'External',
                        label: 'Approve as External Doctor',
                      },
                    ]}
                    gap={{ xs: 2, xl: 1 }}
                    row={true}
                  />
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-5 flex">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0 w-full"
                >
                  <ReusableButton
                    fullWidth={true}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => handleCloseModal()}
                  >
                    Cancel
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={true}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !requestReducer && handleTypeDoctorApprove();
                    }}
                    loading={requestReducer}
                  >
                    Approve
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={rejectModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="fs-24 pt-8 sm:pt-24 family_outfit_semiBold_600">
                  Reject Doctor Request
                </div>
                <div className="mt-16 fs-16 family_outfit_regular_400 lh-208 fc-7B998A pt-12">
                  Do you want to reject this doctor request ?
                </div>
                <div className="pt-20">
                  <div className="">
                    <LabelWithTextArea
                      placeholder={'Write reason...'}
                      height="100"
                      multiline
                      name="rejectReason"
                      Color={'#212426'}
                      padding={'8px'}
                      value={rejectReason}
                      onChange={(e) => setRejectReason(e?.target?.value)}
                      errorText={
                        isError &&
                        isError?.rejectReason?.error &&
                        isError?.rejectReason?.errorMessage
                      }
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-5 flex">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0 w-full"
                >
                  <ReusableButton
                    fullWidth={true}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => setRejectModal(false)}
                  >
                    Cancel
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={true}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !requestReducer && handleRemoveRequest();
                    }}
                    loading={requestReducer}
                  >
                    Submit
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  );
};

export default RequestDetail;
